import { FC } from 'react';
import {
  Box,
  Flex,
  FlexProps,
  Heading,
  Spinner,
  SpinnerProps,
} from '@chakra-ui/react';

type LoadingFragmentProps = FlexProps & {
  heading?: string;
  spinnerProps?: SpinnerProps;
};

const spinnerCss = { '--spinner-track-color': 'colors.gray.200' };

export const LoadingFragment: FC<LoadingFragmentProps> = ({
  children,
  heading,
  spinnerProps,
  ...props
}) => (
  <Flex
    alignItems="center"
    direction="column"
    justifyContent="center"
    textAlign="center"
    w="full"
    {...props}
  >
    <Spinner
      animationDuration="0.75s"
      borderWidth="10px"
      boxSize="120px"
      css={spinnerCss}
      {...spinnerProps}
    />

    {heading && (
      <Heading as="h1" mt={10} size="lg">
        {heading}
      </Heading>
    )}

    {children && (
      <Box mt={6} w="full">
        {children}
      </Box>
    )}
  </Flex>
);
